/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ICustomTheme } from 'interfaces';
import { useState } from 'react';
import { useFormikContext } from 'formik';
import ConfirmDeclarationIcon from 'assets/icons/ConfirmDeclarationIcon';
import { StyledIconContainer } from './styles';
import { DeclarationDialog } from '../Dialog';

export const ConfirmDeclarationDialog = ({
  open,
  handleClose,
  openSubmittedDeclarationDialog,
}: {
  open: boolean;
  handleClose: () => void;
  openSubmittedDeclarationDialog: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();
  const [isSubmissionFailed, setIsSubmissionFailed] = useState(false);
  const { submitForm, isSubmitting, resetForm } = useFormikContext();

  function getSubmitButtonColor() {
    if (isSubmitting) return 'loading';
    if (isSubmissionFailed) return 'error';
    return 'primary';
  }

  const handleConfirm = () =>
    submitForm()
      .then(() => {
        resetForm();
        handleClose();
        openSubmittedDeclarationDialog();
      })
      .catch((error) => {
        console.warn(error);
        setIsSubmissionFailed(true);
      });

  return (
    <DeclarationDialog
      isOpen={open}
      isClosable
      adornment={
        <StyledIconContainer>
          <ConfirmDeclarationIcon color={theme.colors.paletteFromBO.main} />
        </StyledIconContainer>
      }
      onCancel={handleClose}
      onConfirm={handleConfirm}
      title={t('challenges.declaration.confirmDeclaration.title')}
      explanation={t('challenges.declaration.confirmDeclaration.explanation')}
      cancelLabel={t('challenges.declaration.confirmDeclaration.cancel')}
      confirmLabel={t('challenges.declaration.confirmDeclaration.confirm')}
      confirmButtonProps={{
        disabled: isSubmitting,
        color: getSubmitButtonColor(),
      }}
    />
  );
};
